import { useState } from "react";
import {
    Modal,
    ModalContent,
    ModalBody,
} from "@heroui/react";
import { Form } from "./steps/Form";
import { useMediaQuery } from '@custom-react-hooks/use-media-query';
import { useEffect, useRef } from "react";

function useHardScrollLock(isLocked) {
    const scrollY = useRef(0);

    useEffect(() => {
        if (!isLocked) return;

        scrollY.current = window.scrollY;

        const { style } = document.body;
        style.position = "fixed";
        style.top = `-${scrollY.current}px`;
        style.left = "0";
        style.right = "0";
        style.width = "100%";

        return () => {
            const html = document.documentElement;
            const prevBehavior = html.style.scrollBehavior;
            html.style.scrollBehavior = "auto";

            style.position = "";
            style.top = "";
            style.left = "";
            style.right = "";
            style.width = "";
            window.scrollTo(0, scrollY.current);

            html.style.scrollBehavior = prevBehavior;
        };
    }, [isLocked]);
}
export const LoginModal = ({ isOpen, onClose }) => {

    const [currentStep, setCurrentStep] = useState("form")
    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);

    useHardScrollLock(isOpen && !isDesktop); 

    return (
        <Modal isOpen={isOpen}
            onOpenChange={(open) => !open && onClose()}
            size={isDesktop ? "2xl" : "full"}
            classNames={{
                base: "bg-white/75 !px-0 rounded-3xl",
                body: "!px-2",
                header: "!px-2",
                footer: "!px-2",
                backdrop: "bg-black/10 backdrop-saturate-125"
            }}
            placement={isDesktop ? "center" : "top"}
            scrollBehavior={!isDesktop ? "inside" : "normal"}
            backdrop="blur"
            hideCloseButton={isDesktop}
            motionProps={{
                variants: {
                    enter: {
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 0.3,
                            ease: "easeOut",
                        },
                    },
                    exit: {
                        y: -20,
                        opacity: 0,
                        transition: {
                            duration: 0.2,
                            ease: "easeIn",
                        },
                    },
                },
            }}
        >
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalBody className="w-full flex gap-2">
                            {currentStep === "form" && <Form setCurrentStep={setCurrentStep} isDesktop={isDesktop} />}
                        </ModalBody>
                    </>
                )}
            </ModalContent>

        </Modal>
    )
}